/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_newsletter_subscription_failure_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `Zadaná e-mailová adresa je neplatná.`
};

const da_newsletter_subscription_failure_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `Den indtastede e-mailadresse er ugyldig.`
};

const de_newsletter_subscription_failure_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `Die eingegebene E-Mail-Adresse ist ungültig.`
};

const en_newsletter_subscription_failure_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `The email address entered is invalid.`
};

const es_newsletter_subscription_failure_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `La dirección de correo introducida no es válida.`
};

const fr_newsletter_subscription_failure_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `L'adresse email saisie est invalide.`
};

const hu_newsletter_subscription_failure_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `A megadott e-mail cím érvénytelen.`
};

const it_newsletter_subscription_failure_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `L'indirizzo e-mail inserito non è valido.`
};

const nl_newsletter_subscription_failure_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `Het opgegeven e-mailadres is ongeldig.`
};

const pl_newsletter_subscription_failure_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `Wprowadzony adres email jest nieprawidłowy.`
};

const pt_newsletter_subscription_failure_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `O endereço de e-mail introduzido é inválido.`
};

const sv_newsletter_subscription_failure_invalid_email = /** @type {(inputs: {}) => string} */ () => {
	return `Den angivna e-postadressen är ogiltig.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const newsletter_subscription_failure_invalid_email = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.newsletter_subscription_failure_invalid_email(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("newsletter_subscription_failure_invalid_email", locale)
	if (locale === "cs") return cs_newsletter_subscription_failure_invalid_email(inputs)
	if (locale === "da") return da_newsletter_subscription_failure_invalid_email(inputs)
	if (locale === "de") return de_newsletter_subscription_failure_invalid_email(inputs)
	if (locale === "en") return en_newsletter_subscription_failure_invalid_email(inputs)
	if (locale === "es") return es_newsletter_subscription_failure_invalid_email(inputs)
	if (locale === "fr") return fr_newsletter_subscription_failure_invalid_email(inputs)
	if (locale === "hu") return hu_newsletter_subscription_failure_invalid_email(inputs)
	if (locale === "it") return it_newsletter_subscription_failure_invalid_email(inputs)
	if (locale === "nl") return nl_newsletter_subscription_failure_invalid_email(inputs)
	if (locale === "pl") return pl_newsletter_subscription_failure_invalid_email(inputs)
	if (locale === "pt") return pt_newsletter_subscription_failure_invalid_email(inputs)
	return sv_newsletter_subscription_failure_invalid_email(inputs)
};
export { newsletter_subscription_failure_invalid_email as "newsletter.subscription.failure.invalid_email" }